import root from './root.routes'
import register from './register.routes'
import issued from './issued.routes'
import configuration from './configuration.routes'
import proforms from './proforms.routes'
import help from './help.routes'
import multiCompany from './multiCompany.routes'
import debug from './debug.routes'
import home from './home.routes'

export default [
  ...root,
  ...register,
  ...issued,
  ...configuration,
  ...proforms,
  ...help,
  ...multiCompany,
  ...debug,
  ...home
]
